if (!customElements.get('mb-breadcrumb-copy')) {
  customElements.define('mb-breadcrumb-copy', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const item = this.querySelector('.breadcrumb--active');
      if (!item) return;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-current', 'page');

      const copyLink = async () => {

        try {
          const url = new URL(this.dataset.url || window.location.href, window.location.origin);
          url.search = '';
          url.hash = '';

          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url.href);
          } else {
            const input = document.createElement('textarea');
            input.value = url.href;
            input.readOnly = true;
            input.style.cssText = 'position:fixed;left:-9999px;top:0;';
            document.body.appendChild(input);
            try {
              input.select();
              if (!document.execCommand('copy')) throw new Error('Copy failed');
            } finally {
              input.remove();
              item.focus({ preventScroll: true });
            }
          }

        } catch (error) {
          console.warn('Could not copy the breadcrumb link.', error);
        }
      };

      item.addEventListener('click', copyLink);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          copyLink();
        }
      });
    }
  });
}
